import React from 'react'
import styled from 'styled-components'


const ErrorContainer = styled.div`
  padding: 25px;
  text-align: center;
`;
const ErrorIcon = styled.em`
  font-size: 82px;
  color: red;
`;

const ErrorMessage = styled.div`
  font-size: 16px;
  margin-top: 15px;
  margin-bottom: 15px;
`;


class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false,
        error: null,
        info: null
      };
    }
  
    componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({ hasError: true, error: error, info: info });
    }
  
    render() {
      if (this.state.hasError) {
        const { error = "No error message" } = this.state;
        const { info = "No info message" } = this.state;
        const { componentStack = "No stack" } = info;
  
        return (
          <ErrorContainer>
            <ErrorIcon className="fa fa-thumbs-o-down" />
            <h1>Oopps.. Something went wrong.</h1>
            <span>
              Please help us improve Selfpoint by taking a screenshot of the
              messages below and send it to us!
            </span>
            <ErrorMessage>{error.toString()}</ErrorMessage>
            <pre>{componentStack}</pre>
          </ErrorContainer>
        );
      }
      return this.props.children;
    }
  }
  

  export default ErrorBoundary